export const profile = {
  name: "Barsa Rani Ojha",
  title: "Software Developer",
  experience: "3.4+ years",
  email: "barsaraniojha@gmail.com",
  phone: "+91 74401 47634",
  phoneRaw: "917440147634",
  location: "India",
  summary:
    "Software Developer with 3.4 years of experience building responsive web and mobile applications. Proficient across React, Next.js, React Native, TypeScript, Node.js, Express, Prisma, PostgreSQL, and Firebase — delivering scalable products with strong UX and cross-functional collaboration.",
  links: {
    linkedin: "https://www.linkedin.com/in/barsa-rani-ojha-296474233/",
    github: "https://github.com/bArSu45",
    whatsapp: "https://wa.me/917440147634",
    resume: "./Barsa.pdf",
  },
};

export const skills = {
  Frontend: [
    "React JS",
    "Next.js",
    "React Native",
    "Expo",
    "TypeScript",
    "JavaScript",
    "HTML",
    "CSS",
    "Tailwind CSS",
    "Material UI",
    "Bootstrap",
    "Redux Toolkit",
    "React Query",
  ],
  "Backend & Data": [
    "Node.js",
    "Express",
    "Python",
    "FastAPI",
    "Prisma ORM",
    "PostgreSQL",
    "Firebase",
    "Socket.IO",
    "WebSocket",
    "REST APIs",
  ],
  "AI & Tools": [
    "OpenAI API",
    "Claude AI",
    "Google Gemini",
    "Agentic AI",
    "Prompt Engineering",
    "Git",
    "DSA",
  ],
};

export const experience = [
  {
    company: "Declone Labs Pvt Ltd",
    role: "Software Developer",
    location: "Surat, Gujarat",
    period: "Nov 2025 – Present",
    summary:
      "Building AI-driven web and mobile applications with React, Next.js, React Native, TypeScript, and Node.js — integrating LLMs, AI agents, and automation workflows.",
    highlights: [
      "Develop and maintain scalable web and mobile applications",
      "Build real-time features and secure authentication systems",
      "Integrate AI with OpenAI, Claude, and Google Gemini",
      "Optimize performance, state management, and caching",
    ],
  },
  {
    company: "UserEx Consulting Private Limited",
    role: "Software Developer",
    location: "Ahmedabad, Gujarat",
    period: "Nov 2024 – Nov 2025",
    summary:
      "Built responsive, high-performance web and mobile applications with a focus on user-centric design, scalability, and smooth backend integration.",
    highlights: [
      "Developed modular, reusable UI components for web and mobile",
      "Integrated REST APIs and optimized frontend–backend data flow",
      "Maintained Node.js, Express, Prisma, and PostgreSQL services",
      "Implemented secure authentication and session management",
    ],
  },
  {
    company: "Desun Technology",
    role: "Frontend Developer",
    location: "Kolkata, West Bengal",
    period: "Mar 2023 – Aug 2024",
    summary:
      "Designed and delivered high-performance, scalable, and responsive mobile and web applications with a strong focus on UX.",
    highlights: [
      "Crafted complex, interactive UI components",
      "Optimized API services for seamless cross-platform flows",
      "Collaborated with design, backend, and QA for timely delivery",
    ],
  },
];

export const projects = [
  {
    name: "Novon Web",
    tag: "Smart Home Control",
    company: "Declone Labs",
    description:
      "Responsive single-page app for real-time smart home monitoring with JWT auth, socket reconnection, IndexedDB image caching, and Google Maps — improving dashboard responsiveness by ~30%.",
    stack: ["React 19", "Vite", "Redux Toolkit", "Socket.IO"],
    impact: "~30% faster dashboard",
  },
  {
    name: "Novon Mobile",
    tag: "iOS & Android",
    company: "Declone Labs",
    description:
      "Cross-platform smart home app with UDP device discovery, gesture-driven UI via Reanimated, Firebase analytics & crashlytics, and 90%+ shared business logic from a TypeScript SDK.",
    stack: ["React Native", "Redux Toolkit", "Firebase", "Reanimated"],
    impact: "90%+ shared SDK logic",
  },
  {
    name: "Novon Website",
    tag: "Marketing Site",
    company: "Declone Labs",
    description:
      "SEO-optimized marketing site with SSR, structured metadata, and strong Core Web Vitals through Next.js image optimization and static generation.",
    stack: ["Next.js 15", "React 19", "Tailwind CSS"],
    impact: "High Core Web Vitals",
  },
  {
    name: "MyTales",
    tag: "AI Platform",
    company: "Declone Labs",
    description:
      "Full-stack AI storytelling platform with personalized stories and AI image generation via OpenAI, Anthropic, and Google Gemini.",
    stack: ["React", "TypeScript", "Node.js", "PostgreSQL", "Drizzle"],
    impact: "Multi-LLM storytelling",
  },
  {
    name: "Swasth Hriday",
    tag: "Healthcare",
    company: "UserEx",
    description:
      "Healthcare appointment platform with SSR, SEO, secure auth aligned to healthcare data standards, and a 20% lift in user satisfaction.",
    stack: ["Next.js"],
    impact: "+20% user satisfaction",
  },
  {
    name: "Savaar-E Admin",
    tag: "Transport Admin",
    company: "UserEx",
    description:
      "Admin panel for public transport with driver management, real-time status updates, and interactive maps — improving app stability by 35%.",
    stack: ["React JS", "Maps APIs"],
    impact: "+35% stability",
  },
  {
    name: "Sahay CRM",
    tag: "CRM",
    company: "UserEx",
    description:
      "Responsive CRM interfaces with REST API integration and UX optimizations that cut administrative task time by 30%.",
    stack: ["React", "TypeScript", "React Query"],
    impact: "−30% admin time",
  },
  {
    name: "SessionChat",
    tag: "Real-time Chat",
    company: "UserEx",
    description:
      "Full-stack session-based chat with secure auth, persistent profiles, privacy-focused message clearing, Firebase realtime messaging, and Prisma on PostgreSQL.",
    stack: ["React", "Node.js", "Firebase", "Prisma", "PostgreSQL"],
    impact: "Privacy-first sessions",
  },
  {
    name: "Med Mart",
    tag: "Healthcare App",
    company: "Desun",
    description:
      "Doctor booking React Native app with intuitive UX and healthcare provider API integrations — improving UX by 20%.",
    stack: ["React Native"],
    impact: "+20% UX",
  },
  {
    name: "Your Price Cab",
    tag: "Ride Hailing",
    company: "Desun",
    description:
      "Ride-hailing app with polished onboarding, user-set pricing, and improved stability by 35%.",
    stack: ["Expo", "React Native"],
    impact: "+35% stability",
  },
  {
    name: "Club Milli",
    tag: "Services Platform",
    company: "Desun",
    description:
      "Laundry and dry-cleaning service platform with responsive UI, REST APIs, and 25% fewer bug reports after optimization.",
    stack: ["React JS", "Bootstrap"],
    impact: "−25% bug reports",
  },
];

export const education = [
  {
    title: "Full Stack Web Development",
    school: "Masai School",
    place: "Bangalore, India",
    period: "Feb 2022 – Nov 2022",
  },
  {
    title: "MCA",
    school: "Maharishi University of Information & Technology",
    place: "Lucknow, India",
    period: "2019 – 2022",
    meta: "9.0 CGPA",
  },
  {
    title: "B.Sc. (Hons.) Physics",
    school: "Utkal University",
    place: "Bhubaneswar, Odisha",
    period: "2016 – 2019",
    meta: "7.8 CGPA",
  },
];
